import { Route, Routes } from 'react-router'
import VideoEvent from '../pages/VideoEvent.tsx'
import NotFound from '../pages/NotFound.tsx'

const Pages = () => {
  return (
    <Routes>
      {/* Wurzelroute */}
      <Route path="/:topicUrlWithCode" element={<VideoEvent />} />
      {/* Fallback-Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default Pages
